<div class="container">
  <div class="row mb-3"></div>
  <div class="row">
    <div class="card card-body">
      @if (validSession) {
      <nh-provider-welcome
        [peAccessCdArr]="peAccessCdArr"
      ></nh-provider-welcome>
      }
      <router-outlet></router-outlet>
    </div>
  </div>
</div>